import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { ampli } from 'lib-shared-tracking';
import { PureComponent } from 'react';


import HoldMusicWithPlayer from './holdMusicContainer';
import styles from './holdMusicModal.module.scss';

type AudioT = {
  id: string;
};

type PropsT = {
  isOpen: boolean;
  meta: any;
  isHoldModalOpen: boolean;
  orgId: string;
  onClose: VoidFunction;
  editOrganization: (orgId: string, payload: any) => void;
};

type StateT = {
  waitMusicLabelError: string;
  waitMusicValidateClasses: string;
  selectedAudio: AudioT | null;
};

export default class HoldMusicModal extends PureComponent<PropsT, StateT> {
  state: StateT = {
    waitMusicLabelError: '',
    waitMusicValidateClasses: '',
    selectedAudio: null,
  };

  @boundMethod
  onClose(): void {
    ampli.phoneChangeHoldMusicFormCancelled();
    this.props.onClose();
  }

  @boundMethod
  saveClickHandler(): void {
    ampli.phoneChangeHoldMusicFormSubmitted();

    const { selectedAudio } = this.state;
    const { orgId, onClose, editOrganization } = this.props;

    onClose();
    editOrganization(orgId, {
      updates: {
        default_hold_music_id: selectedAudio?.id,
      },
    });
  }

  @boundMethod
  updateAudio({ selectedAudio }: { selectedAudio: AudioT }) {
    this.setState({
      waitMusicLabelError: '',
      waitMusicValidateClasses: '',
      selectedAudio,
    });
  }

  render() {
    const { waitMusicLabelError, waitMusicValidateClasses } = this.state;
    const { onClose, isOpen } = this.props;

    return (
      <Modal className={styles.modal} isOpen={isOpen} onClose={onClose}>
        <ModalHead title="Hold music" onClose={onClose} />

        <ModalBody>
          <HoldMusicWithPlayer
            onSelectedCallback={this.updateAudio}
            labelError={waitMusicLabelError}
            className={waitMusicValidateClasses}
          />
        </ModalBody>

        <ModalFoot
          cancelOnClick={this.onClose}
          confirmName="Save"
          confirmOnClick={this.saveClickHandler}
        />
      </Modal>
    );
  }
}
